import React from 'react';

import { useSpeakerAssociations } from '../../../apis/useSpeakerAssociations';
import Bookmark from '../../../aurr/components/bookmark/Bookmark';
import { WithUserApi } from '../../../common/interface';
import UserNamesList from '../../../components/container/user-names-list';
import Card from '../../../components/presentational/card';
import { CardProps } from '../../../components/presentational/card/Card';
import { generateArticleEyebrow } from '../../search/utils';
import { ArticleResponse } from '../type';
import { generateArticlePathname } from '../utils';

type ArticleCardProps = WithUserApi &
  Partial<CardProps> & {
    articleData: ArticleResponse;
    language?: string;
  };

export function RelatedArticleCard({
  articleData,
  userContentURL,
  userProfileURL,
  width,
  header,
  language,
}: ArticleCardProps) {
  const sysId = articleData?.sys?.id || '';
  const { title, slug } = articleData.fields;
  const overviewImage = articleData.fields.overviewImage?.fields.file.url;

  const { data: classSpeakers } = useSpeakerAssociations({
    contentId: sysId,
    baseURL: userContentURL,
  });

  return (
    <Card
      key={sysId}
      innerPadding={false}
      header={header ?? generateArticleEyebrow(articleData)}
      url={generateArticlePathname(slug, language)}
      title={title}
      width={width}
      bookmark={
        <Bookmark contentID={sysId} contentTitle={title} variant="icon" />
      }
      footer={
        <UserNamesList
          oxygenIds={classSpeakers}
          userContentURL={userContentURL}
          userProfileURL={userProfileURL}
        />
      }
      image={overviewImage}
      cardId={sysId}
      withFallbackImage
    />
  );
}
